import {autoserialize, autoserializeAs, deserializeAs, inheritSerialization} from 'cerialize';
import { BackgroundType } from './background-type';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class Theme extends ModelBase {
  public static readonly type = 'Theme';
  public readonly type = Theme.type;

  @autoserialize
  public id: number;

  @autoserialize
  public name: string;

  @autoserializeAs('color_base_background')
  public baseBackground: string;

  @autoserializeAs('color_base_background_transparent')
  public baseBackgroundTransparent: string;

  @autoserializeAs('color_base_background_semi_transparent')
  public baseBackgroundSemiTransparent: string;

  @autoserializeAs('color_base_foreground')
  public baseForeground: string;

  @autoserializeAs('color_primary_background')
  public primaryBackground: string;

  @autoserializeAs('color_primary_foreground')
  public primaryForeground: string;

  @autoserializeAs('color_primary_background_lighter')
  public primaryBackgroundLighter: string;

  @autoserializeAs('color_primary_background_transparent')
  public primaryBackgroundTransparent: string;

  @autoserializeAs('color_secondary')
  public secondary: string;

  @autoserializeAs('color_tertiary')
  public tertiary: string;

  @autoserializeAs('menu_confetti_visibility')
  public menuConfettiVisibility: string;

  @autoserializeAs('countdown_background_url')
  public countdownBackgroundUrl: string;

  @autoserializeAs('misc_background_url')
  public miscBackgroundUrl: string;

  @autoserializeAs('register_background_url')
  public registerBackgroundUrl: string;

  @autoserializeAs('primary_font')
  public primaryFont: string;

  @autoserializeAs('header_font')
  public headerFont: string;

  @autoserializeAs('filter_color_text')
  public filterColorText: string;

  // These fields are needed to show the preview for the theme. The serialize is needed to convert the preset json file to the model in the component and show the preview.
  @deserializeAs('countdown_background')
  public countdownBackground: string;
  @deserializeAs('misc_background')
  public miscBackground: string;
  @deserializeAs('register_background')
  public registerBackground: string;

  // This method is used so that the theme background returns null if it is not set, and there will not be a /undefined URL in the component HTML.
  public getBackgroundUrl(backgroundType: BackgroundType): string {
    switch (backgroundType) {
      case BackgroundType.CountdownBackground:
        return this.countdownBackground || this.countdownBackgroundUrl;
      case BackgroundType.MiscBackground:
        return this.miscBackground || this.miscBackgroundUrl;
      case BackgroundType.RegisterBackground:
        return this.registerBackground || this.registerBackgroundUrl;
    }
  }
}
